<template>
    <el-dialog
        :title="`${scene == 'add' ? '新增' : '修改'}${
			userTypeInfo[currentData.userType]
		}`"
        width="550px"
        v-model="data.dialogTableVisible"
    >
        <el-form label-width="90px">
            <el-form-item :label="`${userTypeInfo[currentData.userType]}姓名`">
                <el-input
                    v-model="data.formLabelAlign.name"
                    :placeholder="`请输入${
						userTypeInfo[currentData.userType]
					}姓名`"
                ></el-input>
            </el-form-item>
            <el-form-item label="所属站点">
                <el-autocomplete
                    style="width: 100%"
                    v-model="data.cheChangName"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入站点"
                    @select="handleSelect"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item
                :label="`${userTypeInfo[currentData.userType]}手机号`"
            >
                <el-input
                    v-model="data.formLabelAlign.phone"
                    :placeholder="`请输入${
						userTypeInfo[currentData.userType]
					}手机号`"
                ></el-input>
            </el-form-item>

            <el-form-item :label="`余额`">
                <el-input
                    disabled
                    v-model="data.formLabelAlign.totalProce"
                    :placeholder="`请输入余额`"
                ></el-input>
            </el-form-item>
        </el-form>
        <footer class="tac" style="margin-top: 50px">
            <el-button @click="handleCancle">取消</el-button>
            <el-button type="primary" @click="handleSave">确定</el-button>
        </footer>
    </el-dialog>
</template>

<script>
import { defineComponent, inject, reactive } from "vue";
import {
    apiUserInsert,
    apiUserInfoUpdate,
    apiUserParkingLotList,
} from "@/api/requestApis.js";
import { isMobile } from "@/api/utils.js";
import { ElMessage } from "element-plus";
export default defineComponent({
    props: {
        scene: {
            type: String,
            default: "add",
        },
        currentData: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    setup(props) {
        const userTypeInfo = inject("userTypeInfo");
        const handleUpdateTable = inject("handleUpdateTable");
        const data = reactive({
            cheChangName: "",
            dialogTableVisible: false,
            formLabelAlign: {
                name: "",
                parkingLotId: "",
                phone: "",
                deposit: "",
                giftAmount: "",
                totalProce: "",
            },
        });

        const handleReset = () => {
            Object.keys(data.formLabelAlign).forEach((key) => {
                data.formLabelAlign[key] = "";
            });
        };

        const handleSetDefaultVal = () => {
            data.formLabelAlign.name = props.currentData.name;
            data.formLabelAlign.deposit = props.currentData.deposit;
            data.formLabelAlign.giftAmount = props.currentData.giftAmount;
            data.formLabelAlign.totalProce = props.currentData.giftAmount + props.currentData.deposit;
            data.formLabelAlign.parkingLotId = props.currentData.parkingLotId;
            data.formLabelAlign.parkingLotId =
                props.currentData.parkingLotId || "";
            data.cheChangName = props.currentData.parkingName || "";
            data.formLabelAlign.phone = props.currentData.phone;
        };

        const handleToggle = (val) => {
            if (val) {
                if (props.scene === "edit") {
                    setTimeout(() => {
                        handleSetDefaultVal();
                    }, 10);
                }
            }
            data.dialogTableVisible = val;
        };
        const handleSave = async () => {
            if (
                !data.formLabelAlign.name ||
                !data.formLabelAlign.parkingLotId ||
                !data.formLabelAlign.phone
            ) {
                ElMessage.warning("请填写信息");
                return;
            }
            if (!isMobile(data.formLabelAlign.phone)) {
                ElMessage.warning("手机号错误");
                return;
            }
            if (props.scene === "add") {
                await apiUserInsert({
                    ...data.formLabelAlign,
                    userType: props.currentData.userType,
                });
            }
            if (props.scene === "edit") {
                await apiUserInfoUpdate({
                    ...data.formLabelAlign,
                    userType: props.currentData.userType,
                    id: props.currentData.id,
                });
            }
            handleToggle(false);
            handleReset();
            handleUpdateTable();
        };

        const handleCancle = () => {
            handleToggle(false);
            handleReset();
        };
        const querySearchAsync = async (val, cb) => {
            const res = await apiUserParkingLotList({
                name: val,
            });
            const list = res.map((item) => {
                return {
                    value: item.name,
                    ...item,
                };
            });
            cb(list);
        };
        const handleSelect = (val) => {
            data.formLabelAlign.parkingLotId = val.id;
        };
        return {
            userTypeInfo,
            querySearchAsync,
            handleSelect,
            handleCancle,
            handleSave,
            handleToggle,
            data,
        };
    },
});
</script>

<style scoped>
</style>
